import { render, staticRenderFns } from "./AtencionesTab.vue?vue&type=template&id=618ffab7&"
import script from "./AtencionesTab.vue?vue&type=script&lang=ts&"
export * from "./AtencionesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('618ffab7', component.options)
    } else {
      api.reload('618ffab7', component.options)
    }
    module.hot.accept("./AtencionesTab.vue?vue&type=template&id=618ffab7&", function () {
      api.rerender('618ffab7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Atenciones/tabs/AtencionesTab.vue"
export default component.exports